export const texts = {
  title: 'Об учебном заведении',

  chips: {
    founded: 'основан в',
    military: ['военного учебного центра', 'военный учебный центр'],
    hostel: ['общежития', 'общежитие'],
  },
}
